import React, { createContext, FC, useMemo, useContext } from 'react';

type AppDataContextValues = {};

const AppDataContext = createContext<AppDataContextValues>({});

export const AppDataContextProvider: FC = ({ children }) => {
  const value = useMemo(() => ({}), []);
  return <AppDataContext.Provider value={value}>{children}</AppDataContext.Provider>;
};

export const useUsageData = (): AppDataContextValues => useContext(AppDataContext);